var cjsBrowser = {};

export { cjsBrowser as __exports };
//# sourceMappingURL=index3.js.map
